export default {
  receivingOfCultivatedAbolones: [],
  receivingOfCultivatedAbolone: undefined,
};
